export default {
  category: {
    label: 'Kategoriler:',
    default: 'Tüm ürünler',
  },
  cart: {
    title_noproductsincart: 'Sepetinizde ürün bulunmamaktadır.',
    cta_goback: 'Ürün listesine geri dön',
    title_cart: 'Sepet:',
    title_totalamount: 'Toplam:',
    title_discountedamount: 'İndirimli tutar',
    title_coupon: 'Kupon',
    coupon_cta_apply: 'Uygula',
    coupon_placeholder: 'Kupon',
    cta_remove_product: 'Kaldır',
    warning_empty: 'Satın alma adımına ilerlemeden sepetinize bir ürün eklemelisiniz.',
    item: 'ürün | ürüner',
    in_your_cart: 'Alışveriş sepetinizde'
  },
  checkout: {
    title_back: 'Geri',
    title_back_description: 'Ürün listesine geri dön.',
    total: 'Toplam',
    shipping: 'Nakliye'
  },
  errors: {
    license: 'License error.',
    unexpected: 'Unexpected error.'
  },
  footer: {
    banner: '<a href="{link}" target="_blank">{name}</a> ile kendi e-ticaret sitenizi kurun.'
  },
  form: {
    error_blank: '"{field}" alanı boş olamaz.',
  },
  license: {
    expired: 'Lisans süreniz dolmuştur. Satış yapabilmek için lütfen lisansınızı yenileyiniz.',
    close_button: 'kapat'
  },
  list: {
    title_mobile_helper: 'Mobil görünüm',
    description_mobile_helper: 'Siteyi yeni bir sekmede açmak için tıklayın.',
    sale_closed: 'Satışa kapalı'
  },
  modifiers: {
    unselect: 'Seçimi kaldır'
  },
  order_status: {
    title: 'Ödemeniz kontrol ediliyor',
    description: 'Ödemeniz doğrulanıyor. Lütfen sayfayı kapatmadan bekleyiniz. Bu sayfa güncellenecek ve ödemenizin durumunu aşağıda belirecektir..',
  },
  payment_list: {
    title_partial: 'Sadece kısmi ödeme yapmak istiyorum.',
    title_installations: 'Taksit:',

    option_installment: '{installment} * {currency} ile toplam {total} {currency}',
    title_paysecurely: 'Güvenli şekilde öde',
    title_securepayment: 'Ödemeleriniz 256 bit SSL şifrelemesi ile korunmaktadır.',

    info_emptycart: 'Ödeme yapmak için satın almak istediğiniz ürünü sepetinize ekleyin.'
  },
  product: {
    title_selection: 'Ürün seçimi:',
    title_price: 'Fiyat:',
    cta_addtocart: '{price} olarak sepete ekle',
    title_amountselection: 'Seçili tutar:',
    title_closedforsale: 'Bu ürün satışta değildir.',
    cta_checkoutpage: 'Ödeme ekranına git',

    title_slider_next: 'Sonraki ▶',
    title_slider_previous: '◀ Önceki',

    description: 'Açıklaması',
    more_info: 'Ek enformasyon',
    more: 'daha fazla bilgi',
    less: 'daha az bilgi'
  },
  result: {
    title_order_id: 'Sipariş no',
  },
  sort: {
    label: 'Sıralama:',
    default: 'Varsayılan',
    price_asc: 'Ucuzdan pahalıya',
    price_desc: 'Pahalıdan ucuza'
  },
  summary: {
    title: 'Sepet özeti',
    title_total: 'Ödenecek tutar:',
    coupon_cta_apply: 'Uygula',
    coupon_placeholder: 'Kupon',
    coupon_cta_remove: 'Kaldır',
  },
};



// WEBPACK FOOTER //
// ./src/lang/tr.js